import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import { IBoundedContext } from '../../../config';
import { Product, InOutStock } from '../../shared/models';
import { ApiService, ConfigService } from '../../../shared/services';
import { LocationPickerSelection, IQueryString } from '../../../shared/models';

@Injectable()
export class ProductListService {
  products: Array<Product> = [];

  private _inventory: IBoundedContext;

  constructor(
                private _apiService: ApiService,
                private _configService: ConfigService ) {
                        this._inventory = this._configService.getContext('inventory');
                }

  getProducts(filter: IQueryString): Observable<Product[]> {
       return this._apiService.get(this._inventory.url, 'inventory', filter)
                .map(response => response.data.map(p => new Product(p)))
                .cache();
  }

  getStockInformation(location: LocationPickerSelection): Observable<InOutStock> {
        return this._apiService.get(this._inventory.url, `inventory/location/quantity`, location )
                .map(response => {
                    return new  InOutStock(response.inStock, response.outStock);
                })
                .cache();
   }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/services/product-list.service.ts